import {
  ADD_USER_DETAILS_FAILURE,
  ADD_USER_DETAILS_TO_DASHBOARD,
  CHECK_IF_USER_EXIST,
  CHECK_IF_USER_EXIST_FAILURE,
  CHECK_IF_USER_EXIST_SUCCESS,
  DELETE_USER_ADVERTISER_FAILURE,
  FETCHED_ADVERTISERS_FOR_USER_BASED_ON_EMAIL,
  FETCHED_USER_TYPE,
  FETCH_ALL_DASHBOARD_USER_LIST,
  FETCH_FAILURE,
  FETCH_IAM_FAILURE,
  FETCH_IAM_USER_LIST,
  FETCH_LOGOUT,
  FETCH_REQUEST,
  FETCH_USER_DETAILS,
  RESET_ADD_USER_DATA,
  USER_DETAILS_STORED_SUCCESS,
  USER_IAM_ONBOARD_FAILURE,
  USER_IAM_ONBOARD_SUCCESS,
  USER_UI_SETTINGS_ON_TIMEZONE,
  FETCH_ADVERTISER_META_DETAILS,
  FETCH_ADVERTISER_META_DETAILS_SUCCESS,
  FETCH_ADVERTISER_META_DETAILS_FAILURE,
  FETCH_USER_DASHBOARD_PERMISSIONS,
  FETCH_USER_DASHBOARD_PERMISSIONS_SUCCESS,
  FETCH_USER_DASHBOARD_PERMISSIONS_FAILURE,
} from "./userTypes";

import BASE_URL from "../config";
import axios from "axios";
import settings from "../../assets/data/settings.json";

axios.defaults.timeout = 120000; // time in ms to handle logout session
const timeout = 120000; // time in ms to handle logout session
// const BASE_URL = window.location.origin; //process.env.REACT_APP_INTERNAL_SERVER_URL;

export const fetchFailure = (error) => {
  return {
    type: FETCH_FAILURE,
    payload: [],
  };
};
export const fetchRequest = (msg) => {
  return {
    type: FETCH_REQUEST,
    payload: [],
  };
};
export const fetchLogout = (error) => {
  return {
    type: FETCH_LOGOUT,
    payload: error,
  };
};
export const fetchIAMFailure = (error) => {
  return {
    type: FETCH_IAM_FAILURE,
    payload: error,
  };
};
export const userDetailsFetched = (details) => {
  return {
    type: FETCH_USER_DETAILS,
    payload: details.data,
  };
};
export const userPlatformFetched = (details) => {
  return {
    type: FETCH_USER_PLATFORMS,
    payload: details.platform,
  };
};
export const userIAMListFetched = (details) => {
  return {
    type: FETCH_IAM_USER_LIST,
    payload: details,
  };
};
export const setUserTimeZoneSettingsBasedOnSelection = (details) => {
  return {
    type: USER_UI_SETTINGS_ON_TIMEZONE,
    payload: details,
  };
};
export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};
export const deleteCookieByName = (name) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
export const getToken = () => {
  let token;
  if (BASE_URL.includes("dashboard.inmobi.com")) {
    console.log("BASE_URL redirect prod ===>", BASE_URL);
    token = getCookie("_prod_im_auth_token"); // For Prod
  } else if (
    BASE_URL.includes(
      "crun-one-dsp-prod-eus-service-dashboard-s-678648965952.us-east4.run.app"
    )
  ) {
    console.log("BASE_URL redirect staging_utc ===>", BASE_URL);
    token = getCookie("_im_auth_token"); //For staging
  } else if (BASE_URL.includes("dspexternalreportingdashboardjst")) {
    console.log("BASE_URL redirect staging_jst ===>", BASE_URL);
    token = getCookie("_im_auth_token"); //For staging
  } else {
    console.log("Unknown environment. Redirecting to default", BASE_URL);
    token = getCookie("_im_auth_token"); // For Prod
  }
  return token;
};

export const getEnv = () => {
  let env;
  if (BASE_URL.includes("dashboard.inmobi.com")) {
    console.log("BASE_URL redirect prod ===>", BASE_URL);
    env = "prod";
  } else if (
    BASE_URL.includes(
      "crun-one-dsp-prod-eus-service-dashboard-s-678648965952.us-east4.run.app"
    )
  ) {
    console.log("BASE_URL redirect staging_utc ===>", BASE_URL);
    env = "staging";
  } else if (BASE_URL.includes("dspexternalreportingdashboardjst")) {
    console.log("BASE_URL redirect staging_jst ===>", BASE_URL);
    env = "staging";
  } else {
    console.log("Unknown environment. Redirecting to default", BASE_URL);
    env = "staging";
  }
  return env;
};
export const fetchUserDetails = () => (dispatch, getState) => {
  let token;

  console.log('process.env', process.env);

//  if (process.env.REACT_APP_PRODUCTION == 'false') {
//    token = getCookie('_im_auth_token'); //For staging
//  } else {
//    token = getCookie('_prod_im_auth_token'); // For Prod
//  }

    if (BASE_URL.includes('dashboard.inmobi.com')) {
      console.log('BASE_URL redirect prod ===>', BASE_URL);
      token = getCookie('_prod_im_auth_token'); // For Prod
    } else if (BASE_URL.includes('crun-one-dsp-prod-eus-service-dashboard-s-678648965952.us-east4.run.app')) {
      console.log('BASE_URL redirect staging_utc ===>', BASE_URL);
      token = getCookie('_im_auth_token'); //For staging
    } else if (BASE_URL.includes('dspexternalreportingdashboardjst')) {
      console.log('BASE_URL redirect staging_jst ===>', BASE_URL);
      token = getCookie('_im_auth_token'); //For staging
    } else {
      console.log('Unknown environment. Redirecting to default', BASE_URL);
      token = getCookie('_prod_im_auth_token'); // For Prod & _im_auth_token - for Staging
    }

  axios({
    method: "get",
    url: `${BASE_URL}/userDetails`,

    headers: {
      "Content-Type": "application/json",
      userToken: token,
    },
  })
    .then((response) => {
      //console.log(response.data);
      if (response.data.httpCode == 401) {
        return dispatch(fetchFailure(response.data));
      }
      // Store user email for permission fetching
      if (response.data.data && response.data.data.email) {
        localStorage.setItem("userEmail", response.data.data.email);
      }
      dispatch(userDetailsFetched(response.data));
      // Also fetch user permissions
      dispatch(fetchUserDashboardPermissions());
    })
    .catch((err) => {
      return dispatch(fetchFailure("logout"));
    });
};

//export const fetchUserDetails = () => (dispatch, getState) => {
//  let token;
//
//  console.log('REACT_APP_PRODUCTION =>', process.env.REACT_APP_PRODUCTION);
//  if (process.env.REACT_APP_PRODUCTION === 'false') {
//    // Staging
//    token = getCookie('_im_auth_token');
//  } else {
//    // Prod (default)
//    token = getCookie('_prod_im_auth_token');
//  }
//  axios({
//    method: 'get',
//    url: `${BASE_URL}/userDetails`,
//    headers: {
//      'Content-Type': 'application/json',
//      userToken: token
//    }
//  })
//    .then((response) => {
//      if (response.data?.httpCode === 401) {
//        return dispatch(fetchFailure(response.data));
//      }
//      const email = response.data?.data?.email;
//      if (email) {
//        localStorage.setItem('userEmail', email);
//      }
//      dispatch(userDetailsFetched(response.data));
//      dispatch(fetchUserDashboardPermissions());
//    })
//    .catch((err) => {
//      console.error('fetchUserDetails failed:', err);
//      dispatch(fetchFailure('logout'));
//    });
//};

export const fetchIAMUserList = () => (dispatch, getState) => {
  let token;
  if (process.env.REACT_APP_PRODUCTION == "false") {
    token = getCookie("_im_auth_token"); //For staging
  } else {
    token = getCookie("_prod_im_auth_token"); // For Prod
  }
  axios({
    method: "post",
    url: `${BASE_URL}/getOnboardedUsersList`,

    headers: {
      "Content-Type": "application/json",
      // userToken: getCookie("_im_auth_token"),//For staging
      userToken: token, // For Prod
    },
  })
    .then((response) => {
      //console.log(response.data.length);
      //console.log(response.data.data.data.records.length);
      if (response.data.data.data.records.length > 0) {
        //console.log(response.data)
        return dispatch(userIAMListFetched(response.data.data.data.records));
      } else {
        return dispatch(
          fetchIAMFailure("Not able to fetch data. Please retry")
        );
      }
    })
    .catch((err) => {
      return dispatch(fetchIAMFailure("logout"));
    });
};

export const logoutUser = () => (dispatch) => {
  // deleteCookieByName("_im_auth_token")//staging
  let env = getEnv();
  if (env == "prod") {
    //token = getCookie("_im_auth_token"); //For staging
    deleteCookieByName("_im_auth_token");
  } else {
    // token = getCookie("_prod_im_auth_token"); // For Prod
    deleteCookieByName("_prod_im_auth_token");
  }

  return dispatch(fetchLogout("logout"));
};
export const userIAMOnboardSuccess = (details) => {
  //console.log(details);
  return {
    type: USER_IAM_ONBOARD_SUCCESS,
    payload: details,
  };
};
export const userIAMOnboardFailure = (error) => {
  //console.log(details);
  return {
    type: USER_IAM_ONBOARD_FAILURE,
    payload: error,
  };
};
export const sendIAMInvite = (details) => (dispatch) => {
  let token = getToken();
  // if (process.env.REACT_APP_PRODUCTION == 'false') {
  //   token = getCookie('_im_auth_token'); //For staging
  // } else {
  //   token = getCookie('_prod_im_auth_token'); // For Prod
  // }

  //console.log('inside this one', details);
  // Use the firstName and lastName directly if available, otherwise fallback to splitting name
  let fname = details.firstName || details.name.split(" ")[0];
  let lname =
    details.lastName ||
    (details.name.split(" ")[1] ? details.name.split(" ")[1] : "");
  //console.log(fname, lname);
  // Transform payload to match IAM service expectations
  var data = {
    email: details.email,
    sendEmail: true,
    userAttributes: {
      firstName: fname,
      lastName: lname,
      displayName: `${fname} ${lname}`.trim(),
      skypeId: "",
      designation: "",
      phoneNumber: "",
      countryCode: "+91",
    },
  };

  axios({
    method: "post",
    url: `${BASE_URL}/sendIAMInvite`,
    headers: {
      "Content-Type": "application/json",
      usertoken: token,
    },
    data: data,
  })
    .then((response) => {
      // Handle different response structures
      let responseData = response.data;

      // Check if response is empty
      if (!responseData || Object.keys(responseData).length === 0) {
        return dispatch(
          userIAMOnboardFailure(
            "Empty response from IAM service - check backend logs"
          )
        );
      }

      // Log the full response structure for debugging
      if (responseData.data && responseData.data.email) {
        return dispatch(userIAMOnboardSuccess(responseData.data));
      } else if (responseData.email) {
        return dispatch(userIAMOnboardSuccess(responseData));
      } else if (responseData.httpCode === 200) {
        // Even if no email in response, if httpCode is 200, it's successful
        return dispatch(
          userIAMOnboardSuccess({
            email: details.email,
            message: "IAM invite sent successfully",
          })
        );
      } else if (responseData.error) {
        return dispatch(
          userIAMOnboardFailure(`IAM service error: ${responseData.error}`)
        );
      } else {
        // If no email found in response
        return dispatch(
          userIAMOnboardFailure("Invalid response from IAM service")
        );
      }
    })
    .catch((error) => {
      return dispatch(userIAMOnboardFailure("Failed to send IAM invite"));
    });
};
export const resetIAMFormData = () => {
  return {
    type: RESET_ADD_USER_DATA,
    payload: [],
  };
};
export const userAlreadyExist = (details) => {
  //console.log(details);
  return {
    type: CHECK_IF_USER_EXIST,
    payload: details,
  };
};
export const userAlreadyExistFailure = (error) => {
  //console.log(details);
  return {
    type: CHECK_IF_USER_EXIST_FAILURE,
    payload: error,
  };
};
export const saveUserDetailsSuccess = () => {
  return {
    type: USER_DETAILS_STORED_SUCCESS,
    payload: [],
  };
};
export const fetchedDashboardAllUserList = (details) => {
  //console.log(details);
  return {
    type: FETCH_ALL_DASHBOARD_USER_LIST,
    payload: details,
  };
};
export const fetchedUserAssociatedAdvertisersByEmailId = (
  utcAdvertisers,
  jstAdvertisers,
  org_names
) => {
  return {
    type: FETCHED_ADVERTISERS_FOR_USER_BASED_ON_EMAIL,
    payload: {
      utcAdvertisers: utcAdvertisers,
      jstAdvertisers: jstAdvertisers,
      orgNames: org_names,
    },
  };
};
export const checkUserAlreadyExist = (email) => (dispatch) => {
  axios({
    method: "post",
    url: `${BASE_URL}/checkUserExistDashboard`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      email: email,
    },
  })
    .then((response) => {
      //console.log(response.data);
      if (response.data.status == true) {
        return dispatch(userAlreadyExist(true));
      } else {
        return dispatch(userAlreadyExist(false));
      }
    })
    .catch((err) => {
      return dispatch(userAlreadyExist(false));
    });
};
export const userDashboardOnboardSuccess = (details) => {
  //console.log(details);
  return {
    type: ADD_USER_DETAILS_TO_DASHBOARD,
    payload: details,
  };
};
export const saveUserDetailsFailure = (error) => {
  return {
    type: ADD_USER_DETAILS_FAILURE,
    payload: error,
  };
};
// To onboard user to Dashboard
export const onboardUserToDashboard = (data) => (dispatch) => {
  axios({
    method: "post",
    url: `${BASE_URL}/onboardUserAndAdvertiserDetails`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then((response) => {
      if (response.data.status == true) {
        return dispatch(userDashboardOnboardSuccess(true));
      } else {
        return dispatch(saveUserDetailsFailure(response.data.error));
      }
    })
    .catch((err) => {
      return dispatch(userAlreadyExist(false));
    });
};
export const deleteUserAdvertiser = (data) => (dispatch) => {
  axios({
    method: "post",
    url: `${BASE_URL}/deleteAdvertiserDetails`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then((response) => {
      // console.log('delete user Advertiser', response.data);
      if (response.data.status == true) {
        return dispatch(userDashboardOnboardSuccess(true));
      } else {
        return dispatch({
          type: DELETE_USER_ADVERTISER_FAILURE,
          payload: response.data.error,
        });
      }
    })
    .catch((err) => {
      return dispatch(userAlreadyExist(false));
    });
};

//update start date for onboarded user
export const updateStartDate = (data) => (dispatch) => {
  axios({
    method: "post",
    url: `${BASE_URL}/updateStartDate`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  })
    .then((response) => {
      if (response.data.status == true) {
        return dispatch(userDashboardOnboardSuccess(true));
      } else {
        return dispatch(saveUserDetailsFailure(response.data.error));
      }
    })
    .catch((err) => {
      // Error handling
    });
};
// Get all users onboarded to dashboard List not IAM
export const fetchAllDashboardUserList = () => (dispatch) => {
  axios({
    method: "post",
    url: `${BASE_URL}/get_all_dashboard_users_list`,
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      //console.log(response.data);
      if (response.data.length != 0) {
        return dispatch(fetchedDashboardAllUserList(response.data.data));
      } else {
        return dispatch(fetchFailure("Not able to fetch data. Please retry"));
      }
    })
    .catch((err) => {
      return dispatch(fetchFailure("Not able to fetch data. Please retry"));
    });
};
const groupByTimezone = (data) => {
  return data.reduce((acc, item) => {
    const timezone = item.timezone;
    if (!acc[timezone]) {
      acc[timezone] = [];
    }
    acc[timezone].push(item);
    return acc;
  }, {});
};
// Get advertisers mapped for user using email id for JST and UTC
export const fetchAdvertisersListForUserBasedOnEmailId =
  (email) => (dispatch) => {
    axios({
      method: "post",
      url: `${BASE_URL}/get_user_advertiser_details`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        email: email,
      },
    })
      .then((response) => {
        // Check if response has data property (backend sends { data: result })
        if (
          response.data &&
          response.data.data &&
          Array.isArray(response.data.data) &&
          response.data.data.length > 0
        ) {
          const apiData = response.data.data;

          // Filter by selected = "true" as per requirements
          const selectedData = apiData.filter(
            (item) => item.selected === "true"
          );

          if (selectedData.length === 0) {
            console.log();
            return dispatch(
              fetchedUserAssociatedAdvertisersByEmailId([], [], [])
            );
          }

          // Extract organization names from selected advertisers
          const orgNames = selectedData.map((item) => item.org_name);
          const uniqueOrgNames = [...new Set(orgNames)];
          console.log();

          // Separate advertisers by timezone:
          // - timezone = "JST" → JST section
          // - timezone = "UTC" or empty → UTC section
          const jstTimeZoneAdvertisers = selectedData.filter(
            (item) => item.timezone === "JST"
          );
          const utcTimeZoneAdvertisers = selectedData.filter(
            (item) => item.timezone !== "JST"
          );

          return dispatch(
            fetchedUserAssociatedAdvertisersByEmailId(
              utcTimeZoneAdvertisers,
              jstTimeZoneAdvertisers,
              uniqueOrgNames
            )
          );
        } else {
          console.log();
          // Don't call fetchFailure for logout - just return empty data
          return dispatch(
            fetchedUserAssociatedAdvertisersByEmailId([], [], [])
          );
        }
      })
      .catch((err) => {
        console.error(
          "❌ fetchAdvertisersListForUserBasedOnEmailId: Error:",
          err
        );

        // Check if it's an authentication error (401)
        if (err.response && err.response.status === 401) {
          console.error("❌ Authentication error - user may need to re-login");
          // Don't call fetchFailure to prevent logout - just return empty data
          return dispatch(
            fetchedUserAssociatedAdvertisersByEmailId([], [], [])
          );
        }

        // For other errors, don't logout - just return empty data
        console.log();
        return dispatch(fetchedUserAssociatedAdvertisersByEmailId([], [], []));
      });
  };
export const fetchUserTypeFailure = (error) => {
  //console.log('inside fetch user details failure ===>');
  return {
    type: FETCH_USER_TYPE_ERROR,
    payload: [],
  };
};

// Fetch all advertiser meta details for admin users
export const fetchAdvertiserMetaDetails = () => (dispatch) => {
  dispatch({ type: FETCH_ADVERTISER_META_DETAILS });

  axios({
    method: "get",
    url: `${BASE_URL}/get_advertiser_meta_details`,
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (
        response.data &&
        response.data.data &&
        Array.isArray(response.data.data)
      ) {
        const apiData = response.data.data;

        // Process the data similar to how it's done in useAdvertiserData hook
        const jstAdvertisers = apiData.filter(
          (item) => item.timezone === "JST"
        );
        const utcAdvertisers = apiData.filter(
          (item) => item.timezone !== "JST" && item.timezone !== ""
        );
        const emptyTimezoneAdvertisers = apiData.filter(
          (item) => item.timezone === ""
        );

        const processedData = {
          advertisers_utc: [...utcAdvertisers, ...emptyTimezoneAdvertisers].map(
            (item) => ({
              id: item.advertiser_guid || "",
              name: item.advertiser_name || item.name || "",
              org_name: item.org_name || "",
              timezone: "UTC",
              sfId: item.salesforce_account_id || item.sfId || "",
            })
          ),
          advertisers_non_utc: jstAdvertisers.map((item) => ({
            id: item.advertiser_guid || "",
            name: item.advertiser_name || item.name || "",
            org_name: item.org_name || "",
            timezone: "JST",
            sfId: item.salesforce_account_id || item.sfId || "",
          })),
        };

        console.log();

        dispatch({
          type: FETCH_ADVERTISER_META_DETAILS_SUCCESS,
          payload: processedData,
        });
      } else {
        dispatch({
          type: FETCH_ADVERTISER_META_DETAILS_FAILURE,
          payload: "Invalid API response format",
        });
      }
    })
    .catch((err) => {
      console.error("❌ fetchAdvertiserMetaDetails: Error:", err);
      dispatch({
        type: FETCH_ADVERTISER_META_DETAILS_FAILURE,
        payload: err.message || "Failed to fetch advertiser meta details",
      });
    });
};
export const setUserType = (advertiser_list) => {
  // Try to get role from different possible fields
  let userType = advertiser_list.role || advertiser_list.user_type || "client";

  return {
    type: FETCHED_USER_TYPE,
    payload: {
      user_type: userType,
    },
  };
};
// To fetch user role based on email provided already this exist in advertiserActions
export const fetchAdvertiserListForProvidedEmail = (email) => (dispatch) => {
  dispatch(fetchRequest);
  axios({
    method: "post",
    url: `${BASE_URL}/getadvertiserListForUser`,
    header: {
      "Content-Type": "application/json",
    },
    data: {
      userEmail: email,
    },
    timeout: timeout,
  })
    .then((response) => {
      //console.log('response advertiser', response.data);
      if (response.data.data.length > 0) {
        return dispatch(setUserType(response.data.data[0]));
      } else {
        //console.log("inside fetchAdvertiserListFailure");
        return dispatch(fetchUserTypeFailure(""));
      }
    })
    .catch(function (error) {
      //console.log("Show error notification!", error);
      return dispatch(fetchFailure("Not able to fetch data. Please retry"));
      //return Promise.reject(error)
    });
};

export const UpdateUserAdvertiserSettings = (data) => (dispatch) => {
  dispatch(fetchRequest);
  axios({
    method: "post",
    url: `${BASE_URL}/update_user_advertiser_settings`,
    header: {
      "Content-Type": "application/json",
    },
    data: data,
    timeout: timeout,
  })
    .then((response) => {
      //console.log('response advertiser', response.data.data);
      if (response.data.data.length > 0) {
        return dispatch(saveUserDetailsSuccess(response.data.data[0]));
      } else {
        //console.log("inside fetchAdvertiserListFailure");
        return dispatch(saveUserDetailsFailure("Unable To Onboard USer"));
      }
    })
    .catch(function (error) {
      //console.log("Show error notification!", error);
      return dispatch(fetchFailure("Unable To Onboard USer"));
      //return Promise.reject(error)
    });
};
export const setTimeZoneSettings = (timezone, IsSkan) => (dispatch) => {
  let selected_timezone;
  if (timezone == "UTC" && IsSkan == true) {
    selected_timezone = settings.ios_utc;
  }
  if (timezone == "UTC" && IsSkan == false) {
    selected_timezone = settings.android_utc;
  }
  if (timezone == "JST" && IsSkan == false) {
    selected_timezone = settings.non_skan_jst;
  }
  if (timezone == "JST" && IsSkan == true) {
    selected_timezone = settings.skan_jst;
  }
  dispatch(setUserTimeZoneSettingsBasedOnSelection(selected_timezone));
};

export const fetchUserPlatforms = (emailId) => (dispatch, getState) => {
  let token;

  const BASE_URL = process.env.REACT_APP_INTERNAL_SERVER_URL; //window.location.origin

  axios({
    method: "post",
    url: `${BASE_URL}/checkUserPlatform`,

    headers: {
      "Content-Type": "application/json",
    },
    data: {
      email: emailId,
    },
  })
    .then((response) => {
      if (response.data.httpCode == 401) {
        return dispatch(fetchFailure(response.data));
      }
      return dispatch(userPlatformFetched(response.data));
    })
    .catch((err) => {
      //return dispatch(fetchFailure("logout"));
      return dispatch(fetchFailure("Unable to fetch User Platform"));
    });
};

// Default tabs when user has no customization - all except State Level Report
const DEFAULT_TABS_EXCLUDING_STATE_REPORT = [
  'overview',
  'publisher_app_report',
  'creative_report',
  'raw_event_report',
  'wow_report',
  'dod_report',
  'd2c_report'
];

// Action creators for user dashboard permissions
export const fetchUserDashboardPermissions = () => (dispatch, getState) => {
  dispatch({ type: FETCH_USER_DASHBOARD_PERMISSIONS });

  let token;
  if (process.env.REACT_APP_PRODUCTION == "false") {
    token = getCookie("_im_auth_token"); //For staging
  } else {
    token = getCookie("_prod_im_auth_token"); // For Prod
  }

  const userEmail =
    getState().userReducer.userEmail || localStorage.getItem("userEmail");
  const timeZone = getState().advertiserReducer.timeZone || "UTC";
  const isSkan = getState().campaignReducer.isSkan || false;
  const dataType = isSkan ? "skan" : "nonskan";

  axios({
    method: 'get',
    url: `${BASE_URL}/get_user_dashboard_permission?email=${encodeURIComponent(userEmail)}&timezone=${encodeURIComponent(
      timeZone
    )}&data_type=${encodeURIComponent(dataType)}&_t=${Date.now()}`,
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      userToken: token
    }
  })
    .then((response) => {
      if (response.data && response.data.tabs && response.data.widgets) {
        const userPermissions = response.data;

        // Scenario 1: No customization (empty tabs) -> default tabs (all except state_level_report)
        // Scenario 2: API returns tabs -> show exactly what's in the tabs list (no filtering)
        const tabs =
          !userPermissions.tabs || userPermissions.tabs.length === 0
            ? DEFAULT_TABS_EXCLUDING_STATE_REPORT
            : userPermissions.tabs;

        dispatch({
          type: FETCH_USER_DASHBOARD_PERMISSIONS_SUCCESS,
          payload: {
            ...userPermissions,
            tabs,
            context: {
              timezone: timeZone,
              data_type: dataType,
            },
          },
        });
      } else {
        console.log();
        dispatch({
          type: FETCH_USER_DASHBOARD_PERMISSIONS_FAILURE,
          payload: "Invalid response format from permissions API",
        });
      }
    })
    .catch((err) => {
      console.error("❌ fetchUserDashboardPermissions: Error:", err);

      // Check if it's a 404 error - treat as "no customization found"
      // Show all tabs except State Level Report when user has no saved customization
      if (err.response && err.response.status === 404) {
        console.log('🔍 404 Error - No customization found for user, showing all tabs except State Level Report');
        dispatch({
          type: FETCH_USER_DASHBOARD_PERMISSIONS_SUCCESS,
          payload: {
            tabs: DEFAULT_TABS_EXCLUDING_STATE_REPORT,
            widgets: [],
            context: {
              timezone: timeZone,
              data_type: dataType,
            },
          },
        });
        return;
      }

      // For other errors, dispatch failure
      dispatch({
        type: FETCH_USER_DASHBOARD_PERMISSIONS_FAILURE,
        payload: err.message || "Failed to fetch user permissions",
      });
    });
};
